module.exports = __webpack_public_path__ + "img/screen-img-01.76e1bd8f.webp";